import { c as _c } from "react/compiler-runtime";
import { CodeBlock } from '@onefootprint/ui';
type PlainTextViewProps = {
  content: string;
};
const PlainTextView = t0 => {
  const $ = _c(2);
  const {
    content
  } = t0;
  let t1;
  if ($[0] !== content) {
    t1 = <div className="h-full overflow-auto"><CodeBlock language="text">{content}</CodeBlock></div>;
    $[0] = content;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default PlainTextView;